var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiRrExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1856_5685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0C25.671 0 19.4841 1.87677 14.2218 5.39297C8.95939 8.90918 4.85787 13.9069 2.43587 19.7541C0.0138652 25.6014 -0.619842 32.0355 0.614885 38.2429C1.84961 44.4503 4.89732 50.1521 9.3726 54.6274C13.8479 59.1027 19.5497 62.1504 25.7571 63.3851C31.9645 64.6199 38.3987 63.9862 44.2459 61.5642C50.0931 59.1421 55.0908 55.0406 58.607 49.7783C62.1232 44.5159 64 38.329 64 32C63.9908 23.5159 60.6165 15.3819 54.6173 9.38272C48.6181 3.38354 40.4841 0.00917622 32 0V0ZM32 58.6667C26.7258 58.6667 21.5701 57.1027 17.1848 54.1725C12.7995 51.2424 9.38156 47.0776 7.36323 42.2049C5.34489 37.3322 4.8168 31.9704 5.84574 26.7976C6.87468 21.6248 9.41443 16.8732 13.1438 13.1438C16.8732 9.41442 21.6248 6.87467 26.7976 5.84573C31.9704 4.81679 37.3322 5.34488 42.2049 7.36321C47.0776 9.38155 51.2424 12.7995 54.1725 17.1848C57.1027 21.5701 58.6667 26.7258 58.6667 32C58.6589 39.0701 55.8469 45.8483 50.8476 50.8476C45.8483 55.8469 39.0701 58.6589 32 58.6667Z",
    fill: "#DC3C54",
    fillOpacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 13.3337C31.2934 13.3337 30.6151 13.6147 30.115 14.1148C29.6149 14.6149 29.334 15.2932 29.334 16.0004V37.3337C29.334 38.041 29.6149 38.7193 30.115 39.2194C30.6151 39.7195 31.2934 40.0004 32.0007 40.0004C32.7079 40.0004 33.3862 39.7195 33.8863 39.2194C34.3864 38.7193 34.6673 38.041 34.6673 37.3337V16.0004C34.6673 15.2932 34.3864 14.6149 33.8863 14.1148C33.3862 13.6147 32.7079 13.3337 32.0007 13.3337Z",
    fill: "#DC3C54",
    fillOpacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6673 48.0004C34.6673 46.5276 33.4734 45.3337 32.0007 45.3337C30.5279 45.3337 29.334 46.5276 29.334 48.0004C29.334 49.4732 30.5279 50.6671 32.0007 50.6671C33.4734 50.6671 34.6673 49.4732 34.6673 48.0004Z",
    fill: "#DC3C54",
    fillOpacity: 0.98
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1856_5685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrExclamation);
export default __webpack_public_path__ + "static/media/fi-rr-exclamation.600a97e2.svg";
export { ForwardRef as ReactComponent };